import moment                               from "moment";
import { extractEventCodes }                from "./cdaData";
import { extractJSONEventCodes }            from "./cdaDataJSON";
import { getInsFromPatient, remoteFormats } from "./index";

export const extractFindDocumentsParams = (data) => {
  const { ins, insType } = getInsFromPatient(data, remoteFormats.XML);
  
  const parsedEventCodes = extractEventCodes(data);
  
  const
    {
      addAccessAuthorization    : { value: addAccessAuthorization }     = {},
      useBdgAccess              : { value: useBdgAccess }               = {},
      bdgAccessReason           : { value: bdgAccessReason }            = {},
      categories                : { category = [] }                     = {},
      status                    : { value: status }                     = {},
      creationDateBottom        : { value: creationDateBottom }         = {},
      creationDateTop           : { value: creationDateTop }            = {},
      serviceStartDateBottom    : { value: serviceStartDateBottom }     = {},
      serviceStopDateTop        : { value: serviceStopDateTop }         = {},
      submissionDateBottom      : { value: submissionDateBottom }       = {},
      submissionDateTop         : { value: submissionDateTop }          = {},
      invisiblePatient          : { value: invisiblePatient }           = {},
      invisibleRepresentantLegal: { value: invisibleRepresentantLegal } = {},
      masquePS                  : { value: masquePS }                   = {}
    } = data;
  
  //
  // submissionStartDate: moment(submissionDateBottom, 'YYYYMMDDHHmmss').format('DD/MM/YYYY'),
  //   submissionStartDateHour: moment(submissionDateBottom, 'YYYYMMDDHHmmss').format('HH:mm:ss'),
  //
  return {
    ins,
    insType,
    addAccessAuthorization: [true, "true", "1", 1].includes(addAccessAuthorization),
    useBdgAccess: [true, "true", "1", 1].includes(useBdgAccess),
    bdgAccessReason,
    status                      : Number(status),
    categories                  : category.map(c => c.value),
    EventCodes                  : parsedEventCodes,
    creationStartDate           : creationDateBottom ? moment(creationDateBottom, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    creationStartDateHour       : creationDateBottom ? moment(creationDateBottom, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    creationEndDate             : creationDateTop ? moment(creationDateTop, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    creationEndDateHour         : creationDateTop ? moment(creationDateTop, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    actStartDate                : serviceStartDateBottom ? moment(serviceStartDateBottom, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    actStartDateHour            : serviceStartDateBottom ? moment(serviceStartDateBottom, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    actEndDate                  : serviceStopDateTop ? moment(serviceStopDateTop, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    actEndDateHour              : serviceStopDateTop ? moment(serviceStopDateTop, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    submissionStartDate         : submissionDateBottom ? moment(submissionDateBottom, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    submissionStartDateHour     : submissionDateBottom ? moment(submissionDateBottom, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    submissionEndDate           : submissionDateTop ? moment(submissionDateTop, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    submissionEndDateHour       : submissionDateTop ? moment(submissionDateTop, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    patientHidden               : [true, "true", "1", 1].includes(invisiblePatient),
    healthcareProfessionalHidden: [true, "true", "1", 1].includes(masquePS),
    guardianHidden              : [true, "true", "1", 1].includes(invisibleRepresentantLegal)
    
  };
};

export const extractFindDocumentsJSONParams = (data) => {
  const { ins, insType } = getInsFromPatient(data, remoteFormats.JSON);
  
  const parsedEventCodes = extractJSONEventCodes(data);
  
  const
    {
      addAccessAuthorization,
      categories,
      status,
      creationDateBottom,
      creationDateTop,
      serviceStartDateBottom,
      serviceStopDateTop,
      submissionDateBottom,
      submissionDateTop,
      invisiblePatient,
      invisibleRepresentantLegal,
      masquePS,
      useBdgAccess,
      bdgAccessReason
    } = data;
  
  return {
    ins,
    insType,
    addAccessAuthorization,
    useBdgAccess,
    bdgAccessReason,
    status                      : Number(status),
    categories,
    EventCodes                  : parsedEventCodes,
    creationStartDate           : creationDateBottom ? moment(creationDateBottom, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    creationStartDateHour       : creationDateBottom ? moment(creationDateBottom, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    creationEndDate             : creationDateTop ? moment(creationDateTop, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    creationEndDateHour         : creationDateTop ? moment(creationDateTop, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    actStartDate                : serviceStartDateBottom ? moment(serviceStartDateBottom, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    actStartDateHour            : serviceStartDateBottom ? moment(serviceStartDateBottom, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    actEndDate                  : serviceStopDateTop ? moment(serviceStopDateTop, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    actEndDateHour              : serviceStopDateTop ? moment(serviceStopDateTop, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    submissionStartDate         : submissionDateBottom ? moment(submissionDateBottom, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    submissionStartDateHour     : submissionDateBottom ? moment(submissionDateBottom, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    submissionEndDate           : submissionDateTop ? moment(submissionDateTop, "YYYYMMDDHHmmss").format("DD/MM/YYYY") : undefined,
    submissionEndDateHour       : submissionDateTop ? moment(submissionDateTop, "YYYYMMDDHHmmss").format("HH:mm:ss") : undefined,
    patientHidden               : [true, "true", "1", 1].includes(invisiblePatient),
    healthcareProfessionalHidden: [true, "true", "1", 1].includes(masquePS),
    guardianHidden              : [true, "true", "1", 1].includes(invisibleRepresentantLegal)
  };
};